import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import noop from 'lodash/noop';
import { StyledInput } from './TextInput';

export default React.forwardRef(
  (
    {
      value,
      onChange = noop,
      id,
      label,
      hasError,
      helpText,
      hint,
      placeholder,
      autoFocus,
      disablePast,
      disableFuture,
      shouldDisableDate,
      minDate,
      variant,
      ...other
    },
    ref,
  ) => {
    const Component = variant === 'datetime' ? DateTimePicker : DatePicker;
    return (
      <FormControl margin="normal" {...other} error={hasError}>
        {label && <FormLabel>{label}</FormLabel>}
        <Component
          inputRef={ref}
          disablePast={disablePast}
          disableFuture={disableFuture}
          shouldDisableDate={shouldDisableDate}
          minDate={minDate}
          value={value || null}
          onChange={onChange}
          InputProps={{
            placeholder,
          }}
          InputAdornmentProps={{
            sx: { position: 'absolute', right: 14 },
          }}
          renderInput={({ inputRef, inputProps, InputProps }) => (
            <StyledInput
              error={hasError}
              ref={inputRef}
              {...inputProps}
              autoFocus={autoFocus}
              InputProps={InputProps}
              endAdornment={InputProps.endAdornment}
              placeholder={placeholder}
            />
          )}
        />
        {hint && (
          <Typography variant="caption" color="textSecondary">
            {hint}
          </Typography>
        )}
        {hasError && <FormHelperText>{helpText}</FormHelperText>}
      </FormControl>
    );
  },
);
